@if (component) {
<div class="wrap">
    <!-- Header section with title and navigation -->
    <div class="flex flex-justify-between flex-middle m-b">
        <div class="left flex-column">
            <span class="p-b-2 h2"
                  *iCms="'title' of component">
            </span>
            <span class="w-11 p-b-2 p1 text"
                  *iCms="'copy' of component; content: 'html'; skipEmpty: true">
            </span>
            @if (component?.ctaCopy) {
            <span class="p-b-6 left">
                <href class="button-inline"
                      [link]="component.ctaLink"
                      *iCms="'ctaCopy' of component">
                </href>
            </span>
            }
        </div>

        <!-- Navigation arrows in top right -->
        @if (shouldShowNavigation) {
        <div class="flex m-t-6 p-b-5 z-1 _carousel-buttons">
            <button class="b-radius-max m-r-2 flex flex-justify-center flex-middle"
                    [class]="'carousel-prev-' + uid"
                    type="button"
                    [attr.aria-label]="'Previous slide' | translate">
                <i class="icon-chevron-left col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
            <button class="b-radius-max flex flex-justify-center flex-middle"
                    [class]="'carousel-next-' + uid"
                    type="button"
                    [attr.aria-label]="'Next slide' | translate">
                <i class="icon-chevron-right col-6 fs-3 inline-flex"
                   aria-hidden="true">
                </i>
            </button>
        </div>
        }
    </div>

    <!-- Carousel section - full width -->
    <div class="w-12">
        <div class="_swiper-container pos-relative overflow-hidden">
            <carousel class="_swiper"
                      [style.--pc-slides-ceil]="pcSlidesCeil"
                      [style.--pc-slides]="pcSlides"
                      [style.--pc-gutter.px]="pcGutter"
                      [spaceBetween]="pcGutter"
                      [slidesPerView]="pcSlides"
                      [navigation]="shouldShowNavigation ? {
                            nextEl: '.carousel-next-' + uid,
                            prevEl: '.carousel-prev-' + uid
                          } : false"
                      imageViewRoot>
                @for (item of component?.elements; track $index) {
                <ng-template swiperSlide>
                    <href [link]="item.url">
                        <div class="flex-column"
                             [style.gap.px]="20">
                            <!-- Optional image -->
                            @if (item.image) {
                            <div class="ratio-1-1">
                                <img [dfImage]="item.image"
                                     [ratio]="'ratio-1-1'"
                                     [sizes]="['100vw', '33vw', '25vw', '25vw']"
                                     fill />
                            </div>
                            }
                            <div class="flex-column"
                                 [style.gap.px]="item.image ? 8 : 20">
                                <!-- Item title -->
                                <h3 class="h3"
                                    *iCms="'title' of item; content: 'html'; skipEmpty: true">
                                </h3>
                                <!-- Item content (HTML) -->
                                <div
                                     *iCms="'content' of item; content: 'html'; contentClass: [item.contentClass || '', item.contentColor || '']; tag: item.contentTag; skipEmpty: true">
                                </div>
                            </div>
                        </div>
                    </href>
                </ng-template>
                }
            </carousel>
        </div>
    </div>
</div>
}